<template>
  <div class="navBar">
    <div>
      <img src="@/assets/logo.png" alt="" @click="$router.push('/')">
    </div>
    <div @click="$router.push({ name: 'search' })">
      <div><van-icon name="search" class="iconNav"></van-icon></div>
    </div>
    <div>
      <img :src="avantUrl" alt="" @click="$router.push('/user')" v-if="avantUrl">
      <span v-else class="login" @click="$router.push('/login')">
        登录
      </span>
      <div>下载App</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data(){
    return {
      avantUrl:null,
      defaultImg: require('@/assets/head_img.jpg')
    }
  },
  methods:{
    navInit(){
      this.avantUrl = this.$store.getters.isAuthenticated ? this.defaultImg : null;
    }
  },
  mounted() {
    this.navInit()
  }
}
</script>

<style scoped lang="scss">
.navBar{
  position: fixed;  /* 固定位置 */
  top: 0;  /* 距离页面顶部为 0 */
  width: 100%;  /* 占满全宽 */
  z-index: 1000;  /* 保证导航栏在最上层 */
  height: 13.056vw;
  display: flex;
  background-color: white;
  div:nth-child(1) {
    width: 25vw;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
    }
  }
  div:nth-child(2) {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1.389vw;
    div{
      background-color: #f4f4f4;
      height: 6.667vw;
      width: 100%;
      border-radius: 3.333vw;
      position: relative;
      .iconNav{
        color: #aaa;
        position: absolute;
        left: 2.778vw;
        top:50%;
        transform: translate(0, -50%);
      }
    }
  }
  div:nth-child(3){
    display: flex;
    justify-content: center;
    align-items: center;
    div{
      margin: 0 2.778vw;
      font-size: 3.611vw;
      background-color: #fb7299;
      padding: 1.389vw 2.7778vw;
      text-align: center;
      border-radius: 0.833vw;
      color: white;
    }
    img{
      width: 6.944vw;
      height: 6.944vm;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  .login{
    min-width: 7vmin;
    max-width: 7vmin;
    min-height: 7vmin;
    max-height: 7vmin;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e7e7e7;
    color: var(--brand-pink);
    text-align: center;
    font-size: 2.5vmin;
    font-weight: 600;
    white-space: nowrap;
    border-radius: 50%;
  }
}
</style>
